module.exports = __webpack_public_path__ + "static/media/3.01a606ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/mengduo/3.png
// module id = 193
// module chunks = 6